
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'components/ui/card';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface BarChartProps {
  title: string;
  data: any[];
  bars: {
    name: string;
    dataKey: string;
    color: string;
  }[];
  yAxisLabel?: string;
  xAxisLabel?: string;
  description?: string;
}

export function BarChart({
  title,
  data,
  bars,
  yAxisLabel,
  xAxisLabel,
  description,
}: BarChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        <div className="h-80 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <RechartsBarChart
              data={data}
              margin={{
                top: 0,
                right: 30,
                left: 20,
                bottom: 20,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 12 }}
                label={xAxisLabel ? { value: xAxisLabel, position: 'insideBottom', offset: -10 } : undefined}
              />
              <YAxis
                tick={{ fontSize: 12 }}
                label={
                  yAxisLabel
                    ? {
                        value: yAxisLabel,
                        angle: -90,
                        position: 'insideLeft',
                        style: { textAnchor: 'middle' },
                      }
                    : undefined
                }
              />
              <Tooltip />
              <Legend />
              
              {bars.map((bar, index) => (
                <Bar
                  key={bar.dataKey}
                  dataKey={bar.dataKey}
                  name={bar.name}
                  fill={bar.color}
                  stackId={bars.length > 1 ? "a" : undefined}
                  animationDuration={1500 - index * 100}
                />
              ))}
            </RechartsBarChart>
            
          </ResponsiveContainer>
          
        </div>
      </CardContent>
    </Card>
  );
}
